var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgC1RollerShutterTiltDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.63 3h21.86L38.56 14 27.63 3zm31.78 33.27l-2.73-7-38.8-12.06 2.73 7 38.8 12.06zm-.42 11l-2.73-7-38.8-12.07 2.73 7 38.8 12.07zm-.42 11l-2.73-7L17 39.19l2.73 7 38.84 12.08zm-.44 11.44l-2.73-7-38.81-12.08 2.73 7 38.81 12.08z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/C1_Roller_shutter_tilt_down.972af749.svg";
export { SvgC1RollerShutterTiltDown as ReactComponent };